var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDevelopment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#F3D5C2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 32C40.9391 32 39.9217 32.4214 39.1716 33.1716C38.4214 33.9217 38 34.9391 38 36V44C38 45.0609 37.5786 46.0783 36.8284 46.8284C36.0783 47.5786 35.0609 48 34 48H32V52H34C35.0609 52 36.0783 52.4214 36.8284 53.1716C37.5786 53.9217 38 54.9391 38 56V64C38 65.0609 38.4214 66.0783 39.1716 66.8284C39.9217 67.5786 40.9391 68 42 68H46V64H42V54C42 52.9391 41.5786 51.9217 40.8284 51.1716C40.0783 50.4214 39.0609 50 38 50C39.0609 50 40.0783 49.5786 40.8284 48.8284C41.5786 48.0783 42 47.0609 42 46V36H46V32M58 32C59.0609 32 60.0783 32.4214 60.8284 33.1716C61.5786 33.9217 62 34.9391 62 36V44C62 45.0609 62.4214 46.0783 63.1716 46.8284C63.9217 47.5786 64.9391 48 66 48H68V52H66C64.9391 52 63.9217 52.4214 63.1716 53.1716C62.4214 53.9217 62 54.9391 62 56V64C62 65.0609 61.5786 66.0783 60.8284 66.8284C60.0783 67.5786 59.0609 68 58 68H54V64H58V54C58 52.9391 58.4214 51.9217 59.1716 51.1716C59.9217 50.4214 60.9391 50 62 50C60.9391 50 59.9217 49.5786 59.1716 48.8284C58.4214 48.0783 58 47.0609 58 46V36H54V32H58Z",
    fill: "#59595C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevelopment);
export default __webpack_public_path__ + "static/media/development.10441c3e1fa81c2d8a6bb3c5537d0f0a.svg";
export { ForwardRef as ReactComponent };